/*jslint browser: true */
/*globals $, document, jQuery */

import 'owl.carousel';

import './carousel.scss';



const carouselElements = (function() {

  return $('<div/>').addClass('o-carousel-wrapper')
    .append(
      $('<div/>').addClass('o-carousel-nav')
      .append($('<div/>').addClass('o-carousel-nav-prev'))
      .append($('<div/>').addClass('o-carousel-nav-next'))
    ).append(
      $('<div/>').addClass('o-carousel-viewport')
      .append($('<div/>').addClass('owl-carousel owl-theme'))
    ).append(
      (function () {
        var root = $('<div/>').addClass('shadow-carousel')
        var manifest = require('./slide_manifest.json');

        for (var x=0; x < manifest.length; x++) {
          var title = manifest[x][0];
          var categories = manifest[x][1];
          var alias = title;

          for (var i=0; i < categories.length; i++) {
            var name = categories[i][0];
            var count = categories[i][1];

            for (var j=0; j < count; j++) {
              var hash = alias + '-' + name
                + ('00' + j.toString()).slice(-2);

              switch (hash) {

                case "intro-main00":
                  root.append($('<div/>').attr('data-hash', hash)
                    .attr("style", "background-image:" +
                      "url(" +
                      require('../assets/img/' + hash + '.jpg') +
                      ");").append(
                        $("<div/>").addClass("o-interview-article-wrapper")
                        .append($('<div/>').addClass('o-interview-article')
                          .html(require('../assets/artwork/' +
                              'Interview_Transcript.markdown'))
                        )
                        .append($('<div/>').addClass("o-fade-top"))
                        .append($('<div/>').addClass("o-fade-bottom"))
                      )
                  )
                  break;

                case "intro-main01":
                  root.append($('<div/>').attr('data-hash', hash)
                    .attr("style", "background-image:" +
                      "url(" + require('../assets/img/' + hash + '.jpg')
                      + ");"))
                  break;

                default:
                  root.append($('<div/>').attr('data-hash', hash).append(
                    $('<img>').attr('data-src',
                      require('../assets/img/' + hash + '.jpg'))));
                  break;
              }
            };
          };
        }
        return root;
      }())
    )
}())

function onReady() {
  //
  // Assign controls

  $('.o-carousel-wrapper').replaceWith(carouselElements);

  var owl = $('.owl-carousel')
    .on('initialized.owl.carousel', function() {
      $('.o-carousel-viewport')
        .removeClass('hidden');
    });
  if (window.debug) {
    owl.on(
    'initialize.owl.carousel initialized.owl.carousel ' +
    'initialize.owl.carousel initialize.owl.carousel ' +
    'resize.owl.carousel resized.owl.carousel ' +
    'refresh.owl.carousel refreshed.owl.carousel ' +
    'update.owl.carousel updated.owl.carousel ' +
    'drag.owl.carousel dragged.owl.carousel ' +
    'translate.owl.carousel translated.owl.carousel ' +
    'to.owl.carousel changed.owl.carousel' +
    'destroy.owl.carousel', function(e) { console.log(e.type); });
  }


  $(window).on('hashchange', function(event) {
    onHashChange(); return true;});

  $(".o-carousel-nav-next").click(function(){
    $('.owl-carousel').trigger('next.owl');
  });
  $(".o-carousel-nav-prev").click(function(){
    $('.owl-carousel').trigger('prev.owl');
  });

  if (location.hash == '') {
    location.hash = '#intro-main00';
  }

  onHashChange();

}

function sectionFromHash() {
  return location.hash.slice(1).split('-').slice(0, 1)[0];
}

function selectorFromHash(val) {
  return '.shadow-carousel div[data-hash^=' + sectionFromHash() + ']';
}

function updateNav (event) {
  $('.o-carousel-nav-prev').toggleClass('hidden',
    location.hash.match(/#intro/) === null &&
    (event.item.index === 0));
  $('.o-carousel-nav-next').toggleClass('hidden',
    location.hash.match(/#intro/) === null &&
    (event.item.index === event.item.count-1));
}

function onHashChange() {
  var owl = $('.owl-carousel');
  var curFilter = owl.attr('data-filter');

  if (owl.attr('data-filter') != sectionFromHash()) {
    $('.o-carousel-viewport')
      .addClass('hidden');

    setTimeout(function() {
      owl
        .trigger('destroy.owl.carousel')
        .empty()
        .append(
          $(selectorFromHash()).clone().each(function (i, e) {
            var elem = $(e);
            elem.find('img').each(function(i2, e2) {
              var elem2 = $(e2);
              elem2.attr('src', elem2.attr('data-src'))
                .attr('srcset', elem2.attr('data-srcset'))
            });
          })
        )
        .attr('data-filter', sectionFromHash())
        .owlCarousel({
          autoplay: false,
          items: 1,
          loop: location.hash.match(/#intro/) !== null,
          dots: false,
          nav: false,
          navText : ["", ""],
          navContainer: '',
          navClass: [ '', '' ],
          rewindNav : false,
          autoHeight: true,
          smartSpeed: 400,
          animateOut: 'fadeOut',
          //animateIn: 'fadeIn',
          lazyLoad: false,
          margin: 10,
          URLhashListener: true,
          startPosition: 'URLHash',
          onChanged: updateNav })
    }, 500);
  }
  return true;
}


$(document).ready(onReady);

// vim: ss=2 ts=2 sw=2 et



// WEBPACK FOOTER //
// ./webpack/carousel/carousel.js